/**
 * Carbon Size Guide（适配 Ella 7.2.0）
 *
 * 功能：
 *   1. Size 控件标题旁注入 "Sizing Guide" 按钮，点击打开尺码表弹窗（INCH/CM 切换）
 *   2. 选择指定 size 时，下方展示相邻尺寸对照表（前一个 + 当前 + 后一个）
 *
 * 数据配置：
 *   - 所有尺码表数据在下方 SIZE_CHARTS 对象中维护
 *   - 通过 metaobject "size_chart_mapping" 映射 产品类型 → 尺码表ID
 *   - 详见 CARBON-SIZE-GUIDE.md 文档
 *
 * 依赖：
 *   - main-product.liquid 中注入 window.__carbonProductData.sizeChartId
 *   - PUB_SUB_EVENTS.variantChange（主题全局事件）
 */
(function () {
  if (window.__carbonSizeGuideApplied) return;
  window.__carbonSizeGuideApplied = true;

  // ==================== 尺码表数据配置 ====================
  // 在此配置所有尺码表数据，后续更新只需修改此对象
  // 详细配置说明见 CARBON-SIZE-GUIDE.md
  //
  // 字段说明：
  //   title:   弹窗标题
  //   headers: 表头列名（第一列固定为 Size，其余为测量项）
  //   rows:    尺码数据数组
  //     size: 尺码标签（需与产品变体中的 Size 选项值匹配）
  //     inch:  英寸单位的测量值数组（顺序与 headers[1..] 对应，纯数字/范围，不带单位）
  //     cm:    厘米单位的测量值数组（纯数字/范围，不带单位，取整数）
  //            范围值用短横线连接，如 "41-45"、"38-44"
  var SIZE_CHARTS = {
    'default': {
      title: 'Size Chart',
      headers: ['Size', 'Height', 'Weight', 'Bust', 'Waist', 'Length'],
      rows: [
        { size: '4',  inch: ['41-45', '38-44', '23.6', '22', '33.7'],   cm: ['104-114', '17-20', '60', '56', '86'] },
        { size: '6',  inch: ['45-49', '44-55', '25.2', '23', '37.2'],   cm: ['114-124', '20-25', '64', '58', '94'] },
        { size: '8',  inch: ['49-53', '55-66', '26.8', '24.5', '40.9'], cm: ['124-135', '25-30', '68', '62', '104'] },
        { size: '10', inch: ['53-57', '66-77', '28.3', '26', '44.1'],   cm: ['135-145', '30-35', '72', '66', '112'] },
        { size: '12', inch: ['57-61', '77-95', '30', '27.5', '47.8'],   cm: ['145-155', '35-43', '76', '70', '121'] },
        { size: '14', inch: ['61-65', '90-105', '32', '28', '51.6'],    cm: ['155-165', '41-48', '81', '71', '131'] },
        { size: '16', inch: ['65-69', '105-120', '34', '30', '55'],     cm: ['165-175', '48-54', '86', '76', '140'] }
      ]
    },
    '2': {
      title: 'Size Chart',
      headers: ['Size', 'Bust', 'Waist', 'Hips', 'Hollow to Hem'],
      rows: [
        { size: '0',  inch: ['32', '24.5', '34.5', '58'],  cm: ['81', '62', '88', '147'] },
        { size: '2',  inch: ['32.5', '25.5', '35.5', '58'], cm: ['83', '65', '90', '147'] },
        { size: '4',  inch: ['33.5', '26.5', '36.5', '59'], cm: ['85', '67', '93', '150'] },
        { size: '6',  inch: ['34.5', '27.5', '37.5', '59'], cm: ['88', '70', '95', '150'] },
        { size: '8',  inch: ['35.5', '28.5', '38.5', '60'], cm: ['90', '72', '98', '152'] },
        { size: '10', inch: ['36.5', '29.5', '39.5', '60'], cm: ['93', '75', '100', '152'] },
        { size: '12', inch: ['38', '31', '41', '60'],       cm: ['97', '79', '104', '152'] },
        { size: '14', inch: ['39.5', '32.5', '42.5', '60'], cm: ['100', '83', '108', '152'] },
        { size: '16', inch: ['41', '34', '44', '61'],       cm: ['104', '86', '112', '155'] },
        { size: '18', inch: ['43', '36', '46', '61'],       cm: ['109', '91', '117', '155'] },
        { size: '20', inch: ['45', '38', '48', '61'],       cm: ['114', '97', '122', '155'] },
        { size: '22', inch: ['47', '40', '50', '61'],       cm: ['119', '102', '127', '155'] },
        { size: '24', inch: ['49', '42', '52', '61'],       cm: ['124', '107', '132', '155'] }
      ]
    },
    '3': {
      title: 'Size Chart',
      headers: ['Size', 'Bust', 'Waist', 'Hips', 'Hollow to Hem'],
      rows: [
        { size: '0',  inch: ['32', '24.5', '34.5', '58'],  cm: ['81', '62', '88', '147'] },
        { size: '2',  inch: ['32.5', '25.5', '35.5', '58'], cm: ['83', '65', '90', '147'] },
        { size: '4',  inch: ['33.5', '26.5', '36.5', '59'], cm: ['85', '67', '93', '150'] },
        { size: '6',  inch: ['34.5', '27.5', '37.5', '59'], cm: ['88', '70', '95', '150'] },
        { size: '8',  inch: ['35.5', '28.5', '38.5', '60'], cm: ['90', '72', '98', '152'] },
        { size: '10', inch: ['36.5', '29.5', '39.5', '60'], cm: ['93', '75', '100', '152'] },
        { size: '12', inch: ['38', '31', '41', '60'],       cm: ['97', '79', '104', '152'] },
        { size: '14', inch: ['39.5', '32.5', '42.5', '60'], cm: ['100', '83', '108', '152'] },
        { size: '16', inch: ['41', '34', '44', '61'],       cm: ['104', '86', '112', '155'] },
        { size: '18', inch: ['43', '36', '46', '61'],       cm: ['109', '91', '117', '155'] },
        { size: '20', inch: ['45', '38', '48', '61'],       cm: ['114', '97', '122', '155'] },
        { size: '22', inch: ['47', '40', '50', '61'],       cm: ['119', '102', '127', '155'] },
        { size: '24', inch: ['49', '42', '52', '61'],       cm: ['124', '107', '132', '155'] }
      ]
    }
  };

  // ==================== 工具函数 ====================

  function getSizeChartId() {
    var data = window.__carbonProductData || {};
    return data.sizeChartId || 'default';
  }

  function getSizeChart() {
    var id = getSizeChartId();
    return SIZE_CHARTS[id] || SIZE_CHARTS['default'];
  }

  // 判断尺码表是否有有效数据（rows 非空且至少有一行有数据）
  // 无数据时 → 隐藏 Sizing Guide 按钮入口 + 隐藏相邻对照表
  function hasChartData(chart) {
    if (!chart || !chart.rows || !chart.rows.length) return false;
    for (var i = 0; i < chart.rows.length; i++) {
      var r = chart.rows[i];
      if ((r.inch && r.inch.length) || (r.cm && r.cm.length)) return true;
    }
    return false;
  }

  // 判断尺码表支持哪些单位（要求所有行都填了该单位的数据才算支持）
  // 未填的单位 → 对应分页隐藏
  function getAvailableUnits(chart) {
    var units = [];
    if (!chart || !chart.rows || !chart.rows.length) return ['inch'];
    var allInch = true, allCm = true;
    for (var i = 0; i < chart.rows.length; i++) {
      var r = chart.rows[i];
      if (!r.inch || !r.inch.length) allInch = false;
      if (!r.cm || !r.cm.length) allCm = false;
    }
    if (allInch) units.push('inch');
    if (allCm) units.push('cm');
    if (!units.length) units.push('inch'); // 兜底：两者都没填时默认 inch
    return units;
  }

  // 获取实际生效的单位（currentUnit 不可用时回退到第一个可用单位）
  function getEffectiveUnit(chart) {
    var units = getAvailableUnits(chart);
    if (units.indexOf(currentUnit) > -1) return currentUnit;
    return units[0];
  }

  function escapeHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(String(str)));
    return div.innerHTML;
  }

  // 查找 Size 选项容器（排除 Color 选项和 sticky cart）
  function findSizeContainer() {
    var allVariantSelects = document.querySelectorAll('variant-selects');
    var variantSelects = null;
    for (var i = 0; i < allVariantSelects.length; i++) {
      var ctx = allVariantSelects[i].getAttribute('data-context');
      if (ctx && ctx.indexOf('sticky') === 0) continue;
      // 跳过 viewTransition 中的旧节点（display:none）
      if (allVariantSelects[i].style.display === 'none') continue;
      variantSelects = allVariantSelects[i];
      break;
    }
    if (!variantSelects) return null;

    // Ella 7.2.0 产品页：尺码选项容器是 fieldset.product-form__input（--pill / --swatch / --dropdown）
    // 兼容旧版 .variant-option 选择器
    var containers = variantSelects.querySelectorAll('fieldset.product-form__input, .variant-option');
    for (var i = 0; i < containers.length; i++) {
      var label = containers[i].querySelector('legend.form__label, label.form__label');
      if (!label) continue;
      var text = (label.textContent || '').toLowerCase();
      if (text.indexOf('color') > -1 || text.indexOf('colour') > -1) continue;
      if (text.indexOf('size') > -1 || text.indexOf('尺寸') > -1) {
        return containers[i];
      }
    }
    return null;
  }

  // 获取当前选中的 Size 值
  function getSelectedSize() {
    var container = getSizeContainer();
    if (!container) return null;

    var checkedRadio = container.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return checkedRadio.value.trim();

    var select = container.querySelector('select');
    if (select && select.value) return select.value.trim();

    return null;
  }

  // 尺码值标准化（去除 US/UK/EU 前缀，统一小写）
  function normalizeSize(value) {
    if (!value) return '';
    return String(value).trim().toLowerCase().replace(/^(us|uk|eu)\s*/i, '');
  }

  // 在尺码表行中查找匹配的索引
  function findSizeRowIndex(chart, sizeValue) {
    if (!chart || !sizeValue) return -1;
    var normalized = normalizeSize(sizeValue);
    for (var i = 0; i < chart.rows.length; i++) {
      if (normalizeSize(chart.rows[i].size) === normalized) return i;
    }
    // 模糊匹配：尝试提取数字部分
    var numMatch = normalized.match(/(\d+)/);
    if (numMatch) {
      var num = numMatch[1];
      for (var i = 0; i < chart.rows.length; i++) {
        if (normalizeSize(chart.rows[i].size).indexOf(num) === 0) return i;
      }
    }
    return -1;
  }

  // ==================== Sizing Guide 按钮 ====================

  function injectButton(sizeContainer) {
    if (!sizeContainer) return;
    var label = sizeContainer.querySelector('legend.form__label, label.form__label');
    if (!label) return;

    // 无数据时移除已有按钮并不再注入
    var existingBtn = label.querySelector('.carbon-sizing-guide-btn');
    if (!hasChartData(getSizeChart())) {
      if (existingBtn) existingBtn.remove();
      return;
    }
    if (existingBtn) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'carbon-sizing-guide-btn';
    btn.innerHTML = 'Size Chart';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openModal();
    });

    label.appendChild(btn);
  }

  // ==================== 弹窗 ====================

  var currentUnit = 'inch';

  function ensureModal() {
    if (document.getElementById('CarbonSizeGuideModal')) return;

    var chart = getSizeChart();

    var overlay = document.createElement('div');
    overlay.id = 'CarbonSizeGuideOverlay';
    overlay.className = 'carbon-sg-overlay';

    var popup = document.createElement('div');
    popup.id = 'CarbonSizeGuideModal';
    popup.className = 'carbon-sg-popup color-scheme-1';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', 'Size Chart');

    var availableUnits = getAvailableUnits(chart);
    currentUnit = availableUnits[0];

    // 只在两个单位都可用时才渲染切换按钮；只有一个单位时隐藏分页
    var toggleHtml = '';
    if (availableUnits.length > 1) {
      toggleHtml = '<div class="carbon-sg__unit-toggle">';
      availableUnits.forEach(function (unit, idx) {
        toggleHtml += '<button type="button"' + (idx === 0 ? ' class="active"' : '') + ' data-unit="' + unit + '">' + (unit === 'cm' ? 'CM' : 'INCH') + '</button>';
      });
      toggleHtml += '</div>';
    }

    popup.innerHTML =
      '<button class="carbon-sg__close" type="button" aria-label="Close">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg>' +
      '</button>' +
      '<div class="carbon-sg__body">' +
        '<h5 class="carbon-sg__title">' + escapeHtml(chart.title || 'Size Chart') + '</h5>' +
        toggleHtml +
        '<div class="carbon-sg__table-wrap"></div>' +
        '<div class="carbon-sg__notes">' +
          '<p class="carbon-sg__notes-title">Note:</p>' +
          '<ul class="carbon-sg__notes-list">' +
            '<li>The size chart reflects actual body measurements. Please choose a size that aligns with your own measurements, as the dress is designed to provide some stretching room for the wearer.</li>' +
            '<li>The hollow-to-hem measurement of our standard sized floor length dresses already includes an additional 2 inches (ca. 5 cm) to accommodate high heels (including those with Sweep/Court/Chapel/Watteau Train).</li>' +
            '<li>Please note that the size chart serves as a general sizing guide. Specific measurements may vary with each style.</li>' +
          '</ul>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(popup);

    overlay.addEventListener('click', closeModal);
    popup.querySelector('.carbon-sg__close').addEventListener('click', closeModal);

    var toggleBtns = popup.querySelectorAll('.carbon-sg__unit-toggle button');
    Array.prototype.forEach.call(toggleBtns, function (btn) {
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(toggleBtns, function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        currentUnit = btn.getAttribute('data-unit');
        renderModalTable();
        updateComparisonTable();
        updateTipForSelected();
      });
    });

    document.addEventListener('keyup', function (e) {
      if (e.code === 'Escape' && popup.classList.contains('active')) closeModal();
    });

    renderModalTable();
  }

  function renderModalTable() {
    var popup = document.getElementById('CarbonSizeGuideModal');
    if (!popup) return;
    var wrap = popup.querySelector('.carbon-sg__table-wrap');
    if (!wrap) return;

    var chart = getSizeChart();
    var unit = getEffectiveUnit(chart);
    var html = '<table class="carbon-sg__table"><thead><tr>';
    chart.headers.forEach(function (h) {
      html += '<th>' + escapeHtml(h) + '</th>';
    });
    html += '</tr></thead><tbody>';
    chart.rows.forEach(function (row) {
      html += '<tr>';
      html += '<td>' + escapeHtml(row.size) + '</td>';
      var values = unit === 'cm' ? row.cm : row.inch;
      if (values) {
        values.forEach(function (v, i) {
          var header = chart.headers[i + 1];
          html += '<td>' + escapeHtml(formatCellValue(header, v, unit)) + '</td>';
        });
      }
      html += '</tr>';
    });
    html += '</tbody></table>';
    wrap.innerHTML = html;
  }

  function openModal() {
    // 无数据时不打开弹窗
    if (!hasChartData(getSizeChart())) return;
    ensureModal();
    var overlay = document.getElementById('CarbonSizeGuideOverlay');
    var popup = document.getElementById('CarbonSizeGuideModal');
    if (!overlay || !popup) return;

    currentUnit = getAvailableUnits(getSizeChart())[0];
    var toggleBtns = popup.querySelectorAll('.carbon-sg__unit-toggle button');
    Array.prototype.forEach.call(toggleBtns, function (b) {
      b.classList.toggle('active', b.getAttribute('data-unit') === currentUnit);
    });
    renderModalTable();

    requestAnimationFrame(function () {
      overlay.classList.add('active');
      popup.classList.add('active');
    });
    document.body.classList.add('overflow-hidden');
    document.documentElement.setAttribute('scroll-lock', '');
  }

  function closeModal() {
    var overlay = document.getElementById('CarbonSizeGuideOverlay');
    var popup = document.getElementById('CarbonSizeGuideModal');
    if (!overlay || !popup) return;
    overlay.classList.remove('active');
    popup.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.removeAttribute('scroll-lock');
  }

  // ==================== 相邻尺寸对照表 ====================

  function injectComparisonTable(sizeContainer) {
    if (!sizeContainer) return;

    var existing = sizeContainer.nextElementSibling;
    if (existing && existing.classList.contains('carbon-size-comparison')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'carbon-size-comparison';
    wrapper.style.display = 'none';

    sizeContainer.parentNode.insertBefore(wrapper, sizeContainer.nextSibling);
  }

  // 缓存对照表渲染状态：只在 selectedSize/unit 变化时才重建HTML
  var _comparisonCache = { size: null, unit: null };

  function updateComparisonTable() {
    var sizeContainer = getSizeContainer();
    if (!sizeContainer) return;

    injectComparisonTable(sizeContainer);

    var wrapper = sizeContainer.nextElementSibling;
    if (!wrapper || !wrapper.classList.contains('carbon-size-comparison')) return;

    // 尺码表无数据 → 隐藏对照表
    var chart = getSizeChart();
    if (!hasChartData(chart)) {
      wrapper.style.display = 'none';
      wrapper.innerHTML = '';
      _comparisonCache = { size: null, unit: null };
      return;
    }

    var selectedSize = getSelectedSize();
    if (!selectedSize || selectedSize.toLowerCase().indexOf('custom') > -1) {
      wrapper.style.display = 'none';
      wrapper.innerHTML = '';
      _comparisonCache = { size: null, unit: null };
      return;
    }

    var selectedIndex = findSizeRowIndex(chart, selectedSize);
    if (selectedIndex === -1) {
      wrapper.style.display = 'none';
      wrapper.innerHTML = '';
      _comparisonCache = { size: null, unit: null };
      return;
    }

    var unit = getEffectiveUnit(chart);

    // 缓存命中：size 和 unit 都没变，且 wrapper 已有内容（未被DOM重建清空），无需重建
    if (_comparisonCache.size === selectedSize && _comparisonCache.unit === unit && wrapper.innerHTML) {
      wrapper.style.display = '';
      return;
    }
    _comparisonCache.size = selectedSize;
    _comparisonCache.unit = unit;

    // 相邻尺寸：始终显示3行（边界时向另一侧多取一个）
    var showIndices = [];
    var total = chart.rows.length;
    if (selectedIndex === 0) {
      showIndices.push(0);
      if (total > 1) showIndices.push(1);
      if (total > 2) showIndices.push(2);
    } else if (selectedIndex === total - 1) {
      if (total > 2) showIndices.push(total - 3);
      if (total > 1) showIndices.push(total - 2);
      showIndices.push(total - 1);
    } else {
      showIndices.push(selectedIndex - 1);
      showIndices.push(selectedIndex);
      showIndices.push(selectedIndex + 1);
    }

    var availableUnits = getAvailableUnits(chart);

    var html = '<div class="carbon-size-comparison__head">';
    html += '<div class="carbon-size-comparison__label">Size Chart</div>';
    if (availableUnits.length > 1) {
      html += '<div class="carbon-size-comparison__toggle">';
      availableUnits.forEach(function (u) {
        html += '<button type="button"' + (u === unit ? ' class="active"' : '') + ' data-unit="' + u + '">' + (u === 'cm' ? 'CM' : 'INCH') + '</button>';
      });
      html += '</div>';
    }
    html += '</div>';

    html += '<table class="carbon-size-comparison__table"><thead><tr>';
    chart.headers.forEach(function (h) {
      html += '<th>' + escapeHtml(h) + '</th>';
    });
    html += '</tr></thead><tbody>';
    showIndices.forEach(function (idx) {
      var row = chart.rows[idx];
      var isCurrent = idx === selectedIndex;
      html += '<tr' + (isCurrent ? ' class="current"' : '') + '>';
      html += '<td>' + escapeHtml(row.size) + (isCurrent ? ' <span class="carbon-size-comparison__selected">✓</span>' : '') + '</td>';
      var values = unit === 'cm' ? row.cm : row.inch;
      if (values) {
        values.forEach(function (v, i) {
          var header = chart.headers[i + 1];
          html += '<td>' + escapeHtml(formatCellValue(header, v, unit)) + '</td>';
        });
      }
      html += '</tr>';
    });
    html += '</tbody></table>';

    wrapper.innerHTML = html;
    wrapper.style.display = '';

    // 绑定切换按钮：更新 currentUnit 并同步刷新对照表和弹窗
    var toggleBtns = wrapper.querySelectorAll('.carbon-size-comparison__toggle button');
    Array.prototype.forEach.call(toggleBtns, function (btn) {
      btn.addEventListener('click', function () {
        currentUnit = btn.getAttribute('data-unit');
        updateComparisonTable();
        updateTipForSelected();
        // 同步刷新弹窗（如果已打开）
        if (document.getElementById('CarbonSizeGuideModal')) {
          var modalBtns = document.querySelectorAll('#CarbonSizeGuideModal .carbon-sg__unit-toggle button');
          Array.prototype.forEach.call(modalBtns, function (b) {
            b.classList.toggle('active', b.getAttribute('data-unit') === currentUnit);
          });
          renderModalTable();
        }
      });
    });
  }

  // ==================== 尺码提示条（flex子元素插入到当前按钮所在行末尾，占满整行宽度，自然推开下方行） ====================

  var _tooltipEl = null;
  var _tooltipSize = null;
  var _tooltipHost = null;
  // 缓存tip文本，避免重复构建字符串
  var _tipTextCache = {};

  function ensureTooltip(hostEl) {
    if (_tooltipEl && _tooltipHost === hostEl) return _tooltipEl;
    if (_tooltipEl) _tooltipEl.remove();
    _tooltipHost = hostEl;
    _tipTextCache = {};
    var el = document.createElement('div');
    el.className = 'carbon-size-tip';
    el.setAttribute('data-visible', '0');
    el.innerHTML = '<div class="carbon-size-tip__content"></div><button type="button" class="carbon-size-tip__arrow" aria-label="View Size Chart"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button><div class="carbon-size-tip__pointer"></div>';
    el.querySelector('.carbon-size-tip__arrow').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openModal();
    });

    if (hostEl) {
      var cs = getComputedStyle(hostEl);
      if (cs.display.indexOf('flex') === -1) hostEl.style.display = 'flex';
      if (cs.flexWrap === 'nowrap') hostEl.style.flexWrap = 'wrap';
    }
    _tooltipEl = el;
    return el;
  }

  // 根据列名和单位返回单元格的后缀单位
  // Weight 列特殊处理：inch 模式显示 lb，cm 模式显示 kg；其余测量列 in/cm
  function getUnitSuffix(header, unit) {
    if (!header) return '';
    var h = header.toLowerCase();
    if (h.indexOf('weight') > -1) {
      return unit === 'cm' ? 'kg' : 'lb';
    }
    return unit === 'cm' ? 'cm' : 'in';
  }

  // 格式化单元格值：纯数字/范围 + 单位后缀（如 "38-44 lb"、"60 cm"）
  function formatCellValue(header, value, unit) {
    if (value == null || value === '') return '';
    return value + ' ' + getUnitSuffix(header, unit);
  }

  // 构建提示条文字：只显示 Height 和 Weight 信息
  function buildTipText(chart, row, unit) {
    var parts = [];
    var values = unit === 'cm' ? row.cm : row.inch;
    if (!values) return '';
    for (var i = 0; i < values.length; i++) {
      var header = chart.headers[i + 1];
      if (!header || !values[i]) continue;
      var h = header.toLowerCase();
      // 只保留 Height 和 Weight 列
      if (h.indexOf('height') === -1 && h.indexOf('weight') === -1) continue;
      parts.push(header + ': ' + formatCellValue(header, values[i], unit));
    }
    return parts.join(' | ');
  }

  function showTipForRow(chart, row, anchorEl, sizeContainer) {
    if (!row || !anchorEl) return hideTooltip();
    var unit = getEffectiveUnit(chart);
    var host = sizeContainer || anchorEl.parentElement;
    var el = ensureTooltip(host);
    var content = el.querySelector('.carbon-size-tip__content');

    // 缓存tip文本
    var cacheKey = row.size + '|' + unit;
    if (_tipTextCache[cacheKey] === undefined) {
      _tipTextCache[cacheKey] = 'Suggest — ' + buildTipText(chart, row, unit);
    }
    content.textContent = _tipTextCache[cacheKey];
    content.scrollLeft = 0;
    el.setAttribute('data-visible', '1');
    _tooltipSize = getSizeValueFromElement(anchorEl);

    positionTip(anchorEl, host);
  }

  // 定位到当前行末尾：flex-basis:100% 换行占满整行，自然推开下方内容
  function positionTip(anchorEl, hostEl) {
    if (!_tooltipEl || !anchorEl || !hostEl) return;
    var host = hostEl;

    // 清除absolute定位残留的top样式
    _tooltipEl.style.top = '';

    var anchorRect = anchorEl.getBoundingClientRect();
    var anchorTop = anchorRect.top;

    // 找到当前行的最后一个按钮
    var items = getSizeOptionElements(host);
    var rowLastItem = anchorEl;
    items.forEach(function (it) {
      var r = it.getBoundingClientRect();
      if (Math.abs(r.top - anchorTop) < 5 && r.right > rowLastItem.getBoundingClientRect().right) {
        rowLastItem = it;
      }
    });

    // 插入到当前行最后一个按钮之后，flex-basis:100% 使其占满整行宽度
    if (_tooltipEl.parentNode !== host || _tooltipEl.previousElementSibling !== rowLastItem) {
      rowLastItem.insertAdjacentElement('afterend', _tooltipEl);
    }

    // 小三角指向当前按钮中心
    requestAnimationFrame(function () {
      if (!_tooltipEl) return;
      var tipRect = _tooltipEl.getBoundingClientRect();
      var centerX = anchorRect.left + (anchorRect.width / 2) - tipRect.left;
      var pointer = _tooltipEl.querySelector('.carbon-size-tip__pointer');
      if (pointer) {
        pointer.style.left = Math.max(12, Math.min(tipRect.width - 24, centerX)) + 'px';
      }
    });
  }

  function hideTooltip() {
    if (_tooltipEl) _tooltipEl.setAttribute('data-visible', '0');
    _tooltipSize = null;
  }

  // 从尺码按钮 DOM 元素反查其 size 值
  function getSizeValueFromElement(el) {
    if (!el) return null;
    // swatch-item 包裹：radio 是后代
    var radio = el.querySelector('input[type="radio"]');
    if (radio && radio.value) return radio.value.trim();
    // pill/button 模式：el 本身就是 label，radio 是兄弟节点
    if (el.tagName === 'LABEL' && el.htmlFor) {
      var forRadio = document.getElementById(el.htmlFor);
      if (forRadio && forRadio.value) return forRadio.value.trim();
    }
    var opt = el.tagName === 'OPTION' ? el : el.closest('option');
    if (opt) return opt.value.trim();
    return null;
  }

  // 获取尺码按钮元素（radio/option 的 label 或 li 容器）
  function getSizeOptionElements(sizeContainer) {
    if (!sizeContainer) return [];
    // swatch 样式（颜色/图片 swatch）：li.swatch-item
    var swatchItems = sizeContainer.querySelectorAll('.swatch-item');
    if (swatchItems.length) return Array.prototype.slice.call(swatchItems);
    // dropdown 样式：option
    var select = sizeContainer.querySelector('select');
    if (select) {
      return Array.prototype.slice.call(select.options).filter(function(o) { return o.value; });
    }
    // pill/button 样式：radio + label 直接放在 fieldset 下，没有 li 包裹
    // Ella 7.2.0 尺码（非颜色）默认是 product-form__input--pill，input+label 直接为 fieldset 子节点
    var labels = sizeContainer.querySelectorAll('label');
    if (labels.length) return Array.prototype.slice.call(labels);
    return [];
  }

  function initTooltipEvents() {
    var sizeContainer = getSizeContainer();
    if (!sizeContainer) return;

    var chart = getSizeChart();
    if (!hasChartData(chart)) {
      hideTooltip();
      return;
    }

    var items = getSizeOptionElements(sizeContainer);
    if (!items.length) return;

    // 点击显示/切换气泡框（不再使用hover）
    items.forEach(function (item) {
      if (item._carbonTipBound) return;
      item._carbonTipBound = true;

      item.addEventListener('click', function () {
        var sizeVal = getSizeValueFromElement(item);
        if (!sizeVal) return;
        var idx = findSizeRowIndex(chart, sizeVal);
        if (idx === -1) return hideTooltip();
        _tooltipSize = sizeVal;
        showTipForRow(chart, chart.rows[idx], item, sizeContainer);
        updateComparisonTable();
      });
    });

    // 选中时更新
    updateTipForSelected();
  }

  function findSizeItemByValue(sizeContainer, sizeVal) {
    var items = getSizeOptionElements(sizeContainer);
    for (var i = 0; i < items.length; i++) {
      if (getSizeValueFromElement(items[i]) === sizeVal) return items[i];
    }
    // 模糊匹配
    var normalized = normalizeSize(sizeVal);
    for (var j = 0; j < items.length; j++) {
      if (normalizeSize(getSizeValueFromElement(items[j])) === normalized) return items[j];
    }
    return null;
  }

  function updateTipForSelected() {
    var sizeContainer = getSizeContainer();
    if (!sizeContainer) return;
    var chart = getSizeChart();
    if (!hasChartData(chart)) return hideTooltip();

    var selectedSize = getSelectedSize();
    if (!selectedSize) return hideTooltip();
    var idx = findSizeRowIndex(chart, selectedSize);
    if (idx === -1) return hideTooltip();
    var item = findSizeItemByValue(sizeContainer, selectedSize);
    if (!item) return hideTooltip();
    _tooltipSize = selectedSize;
    showTipForRow(chart, chart.rows[idx], item, sizeContainer);
  }

  // ==================== 初始化 ====================

  // 缓存 sizeContainer 引用，避免每次事件都 DOM 查询
  var _cachedSizeContainer = null;

  function getSizeContainer() {
    if (_cachedSizeContainer && document.body.contains(_cachedSizeContainer)) {
      return _cachedSizeContainer;
    }
    _cachedSizeContainer = findSizeContainer();
    return _cachedSizeContainer;
  }

  function invalidateSizeContainer() {
    _cachedSizeContainer = null;
  }

  function doInject() {
    var sizeContainer = getSizeContainer();
    if (sizeContainer) {
      injectButton(sizeContainer);
      injectComparisonTable(sizeContainer);
      updateComparisonTable();
      initTooltipEvents();
    } else {
      hideTooltip();
    }
  }

  function init() {
    doInject();

    // 在产品表单容器上做事件委托，而非整个 document
    function bindEvents() {
      var container = getSizeContainer();
      if (!container) return false;
      var form = container.closest('product-form, form, variant-selects');
      var host = form || container;
      if (host._carbonEventsBound) return true;
      host._carbonEventsBound = true;

      host.addEventListener('change', function (e) {
        var target = e.target;
        if (!target) return;
        var c = getSizeContainer();
        if (c && c.contains(target)) {
          // 尺码radio变化：立即更新内容（主题fetch是异步的，此时DOM还没被替换）
          updateComparisonTable();
          updateTipForSelected();
        }
      }, true);

      host.addEventListener('click', function (e) {
        var target = e.target;
        if (!target) return;
        var c = getSizeContainer();
        if (c && c.contains(target)) {
          // 尺码点击：change事件已处理更新，这里不再 scheduleRefresh 避免重建DOM导致闪烁
        }
      }, true);

      return true;
    }

    bindEvents();

    // 窗口变化时重新定位提示条（宽度变化导致换行变化，需要重新插入到新的行末尾）
    var _resizeRaf = null;
    window.addEventListener('resize', function () {
      if (_resizeRaf) return;
      _resizeRaf = requestAnimationFrame(function () {
        _resizeRaf = null;
        if (_tooltipEl && _tooltipEl.getAttribute('data-visible') === '1' && _tooltipSize) {
          var c = getSizeContainer();
          if (c) {
            var item = findSizeItemByValue(c, _tooltipSize);
            if (item) {
              positionTip(item, c);
            }
          }
        }
      });
    });

    // variantChange 后重新注入（主题每次变体切换都会通过 Section Rendering 替换 product-info DOM）
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        // 主题已替换DOM，需要重新注入按钮/对照表/事件
        // 不调用 hideTooltip()，让 doInject → initTooltipEvents → updateTipForSelected 自然恢复显示
        invalidateSizeContainer();
        // 延迟一帧确保 DOM 替换完成
        requestAnimationFrame(function() {
          doInject();
          bindEvents();
        });
      });
    }

    // 延时兜底：确保异步渲染后 DOM 就绪（已注入则跳过，避免冗余 DOM 操作）
    [500, 1500].forEach(function (ms) {
      setTimeout(function () {
        var container = getSizeContainer();
        if (!container) {
          invalidateSizeContainer();
          doInject();
        } else if (!container.querySelector('.carbon-sizing-guide-btn')) {
          doInject();
        }
        bindEvents();
      }, ms);
    });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
